import presco from "../../assets/img/presco1.png";
import comex from "../../assets/img/comex.jpeg";
import siemens from "../../assets/img/siemens1.png";
import oxxogas from "../../assets/img/oxxogas.png";
import eps1 from "../../assets/img/eps1.png";
import nichos from "../../assets/img/ONICHOS.png";
import auge from "../../assets/img/auge.jpg";
import imperquimia from "../../assets/img/imperquimia.png";
import akron from "../../assets/img/akron.png";
import schneider from "../../assets/img/Schneider.png";
import aba from "../../assets/img/aba.jpg";
import balbek from "../../assets/img/Balbek.png";
import america from "../../assets/img/CAmerica.png";
import kaishan from "../../assets/img/KAISHAN.png";
import canalum from "../../assets/img/canalum.png";
import ciib from "../../assets/img/Logo CIIB dorado.png";

const logos = [
  { src: presco, alt: "PRESCO", width: "w-40" },
  { src: comex, alt: "Comex", width: "w-40" },
  { src: siemens, alt: "SIEMENS", width: "w-40" },
  { src: eps1, alt: "eps", width: "w-28" },
  { src: oxxogas, alt: "OXXO Gas", width: "w-56" },
  { src: nichos, alt: "OXXO Nichos", width: "w-32" },
  { src: auge, alt: "AUGE", width: "w-32" },
  { src: imperquimia, alt: "Imperquimia", width: "w-48" },
  { src: akron, alt: "Akron", width: "w-52" },
  { src: schneider, alt: "Schneider Electric", width: "w-40" },
  { src: aba, alt: "aba", width: "w-28" },
  { src: balbek, alt: "Grupo Corporativo BALBEK", width: "w-36" },
  { src: america, alt: "Colchones America", width: "w-36" },
  { src: canalum, alt: "canalum", width: "w-40" },
  { src: kaishan, alt: "Kaishan", width: "w-36" },
  { src: ciib, alt: "CIIB", width: "w-36" },
];

// Se repite 3 veces para el efecto de scroll infinito
const repeatedLogos = [...logos, ...logos, ...logos];

function Clients() {
  return (
    <>
      <section id="clients" className="mt-6 sm:mt-8 md:mt-10">
        <div className="w-full p-2 sm:p-3 md:p-4">
          <p className="font-extrabold text-xl sm:text-xl md:text-2xl lg:text-2xl text-[#1e72b9] text-center mb-3 sm:mb-4 md:mb-6">
            ALIANZAS ESTRATÉGICAS
          </p>
          <p className="font-bold text-2xl sm:text-3xl md:text-4xl lg:text-5xl text-[#29265b] text-center">
            Colaboraciones de Suministro
          </p>
          <p className="font-medium text-xl sm:text-2xl md:text-3xl lg:text-4xl text-[#29265b] text-center">
            con Grandes Industrias
          </p>
          <div className="mt-6 sm:mt-8 md:mt-10">
            <div className="mt-4 sm:mt-5 md:mt-6 mb-4 sm:mb-5 md:mb-6 relative overflow-hidden">
              <div className="logo-slider pause-animation-on-hover overflow-hidden relative w-full">
                <div
                  className="logo-slide-track flex animate-logo-scroll"
                  style={{ width: `calc(250px * ${repeatedLogos.length})` }}
                >
                  {repeatedLogos.map((logo, index) => (
                    <div
                      key={index}
                      className="logo-slide flex items-center justify-center min-w-[200px] sm:min-w-[220px] md:min-w-[250px]"
                    >
                      <img
                        className={`${logo.width} object-contain mx-4`}
                        src={logo.src}
                        alt={logo.alt}
                        loading="lazy"
                        decoding="async"
                      />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Botón "Accede a oportunidades exclusivas" */}
        <div className="flex justify-center w-full mt-2 sm:mt-3 md:mt-4">
          <a
            onClick={() => (window.location.href = "/registrate")}
            className="bg-[#39a8e0] text-white px-4 sm:px-5 md:px-6 py-2 sm:py-2.5 md:py-3 mt-4 sm:mt-5 md:mt-6 rounded-[10px] flex items-center justify-between cursor-pointer hover:bg-[#1e72b9] transition-colors"
          >
            <div className="flex flex-col text-center">
              <span className="text-base sm:text-lg font-semibold">
                Quiero ser parte de IBC
              </span>
            </div>
          </a>
        </div>
      </section>
      {/*-------------------- Fin contenedor de logotipos "Colaboraciones" --------------------*/}
    </>
  );
}

export default Clients;
